import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { dateFormat, openAlert } from '../../utils/common';
import '../../assets/css/common.css';
import '../../assets/css/main.css';
import '../../assets/css/adm_custom.css';
import '../../assets/css/guide.css';
import SectionContainer from '../../components/UI/SectionContainer';
import SortController from '../../components/UI/SortController';
import Spinner from '../../components/UI/Spinner';
import popupService from '../../services/popupService';

const PopupListPage = () => {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState([]);
  const [initList, setInitList] = useState([]);
  const navigate = useNavigate();

  const fetchList = async () => {
    setLoading(true);
    try {
      const result = await popupService.getPopupList();
      if (result.success) {
        setList(result.data);
        setInitList(result.data.map(item => item.idx));
      } else {
        openAlert({ title: '알림', description: result.message });
      }
    } catch (e) {
      console.error(e); 
      openAlert({ title: '알림', description: '데이터 로드 중 오류가 발생했습니다.' });
    } finally { 
      setLoading(false); 
    }
  };

  useEffect(() => { fetchList(); }, []);

  const toggleSelect = (idx) => {
    setSelected(prev => prev.includes(idx)
      ? prev.filter(i => i !== idx)
      : [...prev, idx]
    );
  };

  const selectAll = (e) => {
    if (e.target.checked) setSelected(list.map(i => i.idx));
    else setSelected([]);
  };

  const handleDelete = async () => {
    if (!selected.length) { 
      openAlert({ title: '알림', description: '삭제할 게시글을 선택해주세요.' }); 
      return; 
    }
    if (!window.confirm('선택하신 게시글을 정말로 삭제하시겠습니까?')) return;
    
    setLoading(true);
    try {
      const result = await popupService.deletePopups(selected);
      if (result.success) {
        fetchList();
      } else {
        openAlert({ title: '알림', description: result.message });
      }
    } catch (e) { 
      console.error(e); 
      openAlert({ title: '알림', description: '삭제 중 오류가 발생했습니다.' }); 
    } finally { 
      setLoading(false); 
    }
  };

  const changeUse = async (idx, state) => {
    try {
      const result = await popupService.changePopupState(idx, state);
      if (result.success) {
        setList(prev => prev.map(item => item.idx === idx ? { ...item, use_state: state } : item));
      } else {
        openAlert({ title: '알림', description: result.message });
      }
    } catch (e) { 
      console.error(e); 
      openAlert({ title: '알림', description: '사용여부 변경 중 오류가 발생했습니다.' }); 
    }
  };

  const handleApply = async () => {
    const arr = list.map(i => i.idx);
    if (JSON.stringify(arr) === JSON.stringify(initList)) {
      openAlert({ title: '알림', description: '게시글 순서가 변경되지 않았습니다.' });
      return;
    }
    setLoading(true);
    try {
      const result = await popupService.changePopupSequence(arr);
      if (result.success) { 
        openAlert({ title: '알림', description: '게시글 순서가 변경되었습니다.' }); 
        setInitList(arr); 
      } else {
        openAlert({ title: '알림', description: result.message });
      }
    } catch(e){ 
      console.error(e); 
      openAlert({ title: '알림', description: '순서 변경 중 오류가 발생했습니다.' }); 
    } finally { 
      setLoading(false); 
    }
  };
  const handleReset = () => fetchList();

  return (
    <SectionContainer title="팝업 관리" className="faq_setting list">
      <Spinner visible={loading} />
      <div className="search_area">
        <div className="acc_total">
          <h4><b>{list.length}</b>개 검색되었습니다.</h4>
        </div>
        <div className="left">
          <div className="but-flex">
            <button className="btn btn-md primary mr-1" onClick={() => navigate('write')}>팝업등록</button>
            <button className="btn btn-lg tertiary" onClick={handleDelete}>삭제</button>
          </div>
        </div>
      </div>
      <div className="content_area">
        <div className="table_area col-md-11">
          <div className="table">
            <table>
              <thead>
                <tr>
                  <th><input type="checkbox" onChange={selectAll} checked={selected.length===list.length}/></th>
                  <th>No</th>
                  <th style={{width:'35%'}}>팝업명</th>
                  <th>등록일</th>
                  <th>사용여부</th>
                  <th>수정</th>
                </tr>
              </thead>
              <tbody data-wrap="wrap">
                {list.length===0 && !loading && <tr><td colSpan="6">팝업 내역이 존재하지 않습니다.</td></tr>}
                {list.map((item, i)=>(
                  <tr key={item.idx} className={selected.includes(item.idx)?'on':''}>
                    <td><input type="checkbox" checked={selected.includes(item.idx)} onChange={()=>toggleSelect(item.idx)}/></td>
                    <td>{i+1}</td>
                    <td className="un_line" style={{cursor:'pointer'}} onClick={()=>navigate(`edit/${item.idx}`)}>{item.title_ko}</td>
                    <td>{dateFormat(item.reg_date)}</td>
                    <td>
                      <div className="toggle_button">
                        <label className="label">
                          <input className="toggle_input" type="checkbox" role="switch" checked={item.use_state===1} onChange={e=>changeUse(item.idx, e.target.checked?1:0)}/>
                          <span></span>
                        </label>
                      </div>
                    </td>
                    <td><input type="button" className="btn fourbtn" onClick={()=>navigate(`edit/${item.idx}`)} value="수정하기"/></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <SortController
          list={list}
          setList={setList}
          selected={selected}
          handleApply={handleApply}
          handleReset={handleReset}
        />
      </div>
    </SectionContainer>
  );
};

export default PopupListPage;
